import RequestStatisticBlockReducer from './RequestStatisticBlockReducer';

export default from './RequestStatisticBlockContainer';

export const RequestStatisticBlockReducers = {
  RequestStatisticBlockReducer,
};
